import { getItemsAnalytics, getTransactionAnalytics } from '@ynap/analytics'

export const removeRestrictedItem = ({ restrictedItems, checkoutAnalytics }) => ({
    category: {
        primaryCategory: 'ecommerce',
        subCategory: 'checkout'
    },
    event: 'remove from cart - some',
    effect: 'update cart',
    item: getItemsAnalytics(restrictedItems),
    attributes: {
        restrictedItems: 'some',
        restrictionReason: ['Hazmat']
    },
    transaction: getTransactionAnalytics(checkoutAnalytics)
})

export const addRestrictedItemToWL = ({ checkoutAnalytics }) => ({
    category: {
        primaryCategory: 'checkout',
        subCategory: 'restricted items'
    },
    event: 'add restricted item to wishlist',
    effect: 'add items to wishlist',
    transaction: getTransactionAnalytics(checkoutAnalytics)
})

export const hazmatOverlayDisplayed = (props) => {
    const numberOfRestrictedItems = props.restrictedItems.length
    const checkoutAnalytics = props.checkoutAnalytics
    return {
        event: 'remove restricted items dialog displayed',
        effect: 'prompt user to remove restricted items',
        category: {
            primaryCategory: 'checkout',
            subCategory: 'shipping address'
        },
        attributes: {
            restrictedItems: 'some',
            numberOfRestrictedItems
        },
        transaction: getTransactionAnalytics(checkoutAnalytics)
    }
}
